import React, { useMemo } from "react";
import { useTable, useSortBy, useGlobalFilter, usePagination } from "react-table";
import { Table, Input } from "reactstrap";
import { SearchFilter } from "../share/SearchFilter";
import { ChevronLast, ChevronFirst, ChevronRight, ChevronLeft, ChevronsUpDown } from 'lucide-react';


export default function CreateTableComponent(props) {

    const { column, dataInput, FormInput, showEntrie, showPage } = props

    const columns = useMemo(() => column, [column])
    const data = useMemo(() => dataInput, [dataInput])

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        page,
        nextPage,
        previousPage,
        canNextPage,
        canPreviousPage,
        pageOptions,
        gotoPage,
        pageCount,
        prepareRow,
        setPageSize,
        state,
        setGlobalFilter } = useTable({
            columns: columns,
            data: data
        },
            useGlobalFilter,
            useSortBy,
            usePagination
        )

    const { globalFilter, pageIndex, pageSize } = state

    return (
        <>

            <div className="d-flex justify-content-between align-items-center">
                {showEntrie ?
                    <div className="d-flex justify-content-between align-items-center">
                        <div className="d-flex align-items-center">
                            <span className="mx-2">
                                แสดง {" "}
                            </span>

                            <Input className="input-color w-50 rounded-pill" type="select" value={pageSize} onChange={e => setPageSize(Number(e.target.value))}>
                                {
                                    [5, 10, 25, 50].map(pageSize => (
                                        <option key={pageSize} value={pageSize}>
                                            {pageSize}
                                        </option>
                                    ))
                                }
                            </Input>
                            <span className="mx-2">{" "} รายการ {" "}</span>

                        </div>
                        <SearchFilter search={globalFilter} setSearch={setGlobalFilter} />
                    </div>
                    :
                    <div style={{ visibility: "hidden" }}></div>
                }
                {FormInput ?
                    <FormInput />
                    :
                    <></>
                }
            </div>
            <div style={{ overflowX: "auto" }}>
                <Table className="styled-table mt-2" stype={{ backgroundColor: "#ffff"}} striped bordered  {...getTableProps()}>
                    <thead className="text-center">
                        {headerGroups.map((headerGroup) => (
                            <tr {...headerGroup.getHeaderGroupProps()} >
                                {
                                    headerGroup.headers.map((column) => (
                                        <th {...column.getHeaderProps(column.getSortByToggleProps())}>
                                            {column.render('Header')}
                                            <span>
                                                <ChevronsUpDown size={24} color="#ffff" />
                                            </span>
                                        </th>
                                    ))
                                }
                            </tr>
                        ))}
                    </thead>
                    <tbody {...getTableBodyProps()}>
                        {!page.length ? (
                            <tr>
                                <td className="text-center" colSpan={columns.length}>ไม่มีข้อมูล</td>
                            </tr>
                        ) : (
                            <>
                                {page.map(row => {
                                    prepareRow(row)
                                    return (
                                        <tr className="text-center" {...row.getRowProps()}>
                                            {
                                                row.cells.map((cell) => {
                                                    return <td {...cell.getCellProps()}>{cell.render("Cell")}</td>
                                                })
                                            }
                                        </tr>
                                    )
                                })
                                }
                            </>
                        )}

                    </tbody>
                </Table>
                {showPage ?
                    <div className="d-flex justify-content-between align-items-center">
                        <div>
                            <button className="btn border border-1" onClick={() => gotoPage(0)} disabled={!canPreviousPage}> <ChevronFirst color="#0A66C2" /></button>
                            <button
                                className="border border-1 btn"
                                onClick={() => previousPage()}
                                disabled={!canPreviousPage}
                            >
                                <ChevronLeft color="#0A66C2" />
                                {/* ก่อนหน้า */}
                            </button>
                        </div>

                        <span className="">
                            หน้าที่ {" "}
                            <span className="page-count">
                                {pageIndex + 1} / {pageOptions.length}
                            </span>
                        </span>
                        <div>

                            <button
                                className="border border-1 btn"
                                onClick={() => nextPage()}
                                disabled={!canNextPage}
                            >
                                {/* ถัดไป */}
                                <ChevronRight color="#0A66C2" />
                            </button>
                            <button className="btn border border-1" onClick={() => gotoPage(pageCount - 1)} disabled={!canNextPage}><ChevronLast color="#0A66C2" /></button>
                        </div>
                    </div>
                    :
                    <></>
                }
            </div>


        </>




    )

}